import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '@env/environment';
import {
  CreateLandlordRequest,
  CreateLocationRequest,
  CreateOfferingRequest,
  CreateOfferingResponse,
} from './setup.model';

@Injectable({
  providedIn: 'root'
})
export class SetupService {
  constructor(private http: HttpClient) {}

  createLandlord(req: CreateLandlordRequest): Observable<{ uuid: string }> {
    return this.http.post<{ uuid: string }>(`${this.baseUrl}/landlords`, req);
  }

  createLocation(landlordUuid: string, req: CreateLocationRequest): Observable<{ uuid: string }> {
    return this.http.post<{ uuid: string }>(`${this.baseUrl}/landlords/${landlordUuid}/locations`, req);
  }

  createOffering(locationUuid: string, req: CreateOfferingRequest): Observable<CreateOfferingResponse> {
    return this.http.post<CreateOfferingResponse>(`${this.baseUrl}/locations/${locationUuid}/offerings`, req);
  }

  uploadLandlordLogo(landlordUuid: string, file: File): Observable<void> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<void>(`${this.baseUrl}/landlords/${landlordUuid}/logo`, formData);
  }

  uploadLocationTileImage(locationUuid: string, file: File): Observable<void> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<void>(`${this.baseUrl}/locations/${locationUuid}/tile-image`, formData);
  }

  uploadLocationBannerImage(locationUuid: string, file: File): Observable<void> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<void>(`${this.baseUrl}/locations/${locationUuid}/banner-image`, formData);
  }

  uploadOfferingTileImage(offeringUuid: string, file: File): Observable<void> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<void>(`${this.baseUrl}/offerings/${offeringUuid}/tile-image`, formData);
  }

  uploadOfferingBannerImage(offeringUuid: string, file: File): Observable<void> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<void>(`${this.baseUrl}/offerings/${offeringUuid}/banner-image`, formData);
  }

  private get baseUrl(): string {
    return environment.apiLandlordHost + '/admin';
  }
}